import salesExpensesMSTAddPage from './SalesExpensesMSTAddPage';

export default salesExpensesMSTAddPage;
